import React from 'react';
import ReactECharts from 'echarts-for-react';
import StatCard from '../ui/StatCard';
import Badge from '../ui/Badge';
import SafeIcon from '../../common/SafeIcon';
import { initialInvoices, mockProjects } from '../../data/mockData';

export default function Dashboard() {
  const chartOptions = {
    tooltip: { trigger: 'axis', backgroundColor: '#1A1A1A', borderColor: '#333', textStyle: { color: '#FDFBF7' } },
    grid: { top: 40, right: 20, bottom: 20, left: 40, containLabel: true },
    xAxis: { 
      type: 'category', 
      data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
      axisLine: { lineStyle: { color: '#333' } },
      axisLabel: { color: 'rgba(253, 251, 247, 0.6)' }
    },
    yAxis: { 
      type: 'value',
      splitLine: { lineStyle: { color: '#222', type: 'dashed' } },
      axisLabel: { color: 'rgba(253, 251, 247, 0.6)', formatter: '${value}k' }
    },
    series: [
      {
        name: 'Revenue',
        data: [12, 19, 15, 25, 22, 30],
        type: 'line',
        smooth: true,
        symbol: 'none',
        lineStyle: { color: '#10B981', width: 3 },
        areaStyle: {
          color: {
            type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [{ offset: 0, color: 'rgba(16,185,129,0.3)' }, { offset: 1, color: 'rgba(16,185,129,0)' }]
          }
        }
      }
    ]
  };

  return (
    <div className="space-y-6 animate-in fade-in duration-500">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <StatCard title="Monthly Recurring Revenue" value="$42,500" trend="+12.5%" trendUp={true} icon="DollarSign" />
        <StatCard title="Outstanding Invoices" value="$12,600" trend="-2.4%" trendUp={false} icon="Clock" />
        <StatCard title="Team Capacity" value="78%" trend="+5.0%" trendUp={true} icon="Users" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 glass-panel rounded-xl p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-lg font-medium text-cream">Profit Snapshot</h2>
            <div className="flex items-center gap-2">
              <Badge variant="success">Up 14% vs Q2</Badge>
            </div>
          </div>
          <ReactECharts option={chartOptions} style={{ height: '300px' }} />
        </div>

        <div className="glass-panel rounded-xl p-6 flex flex-col">
          <h2 className="text-lg font-medium text-cream mb-6">Margin by Project</h2>
          <div className="space-y-4 flex-1">
            {mockProjects.map((proj, i) => (
              <div key={i} className="flex flex-col gap-2 p-3 bg-charcoal-light/30 rounded-lg border border-[#333]">
                <div className="flex justify-between items-center">
                  <span className="text-sm font-medium text-cream">{proj.name}</span>
                  <span className={`text-xs font-mono ${proj.status === 'At Risk' ? 'text-red-400' : 'text-invoice-green'}`}>
                    {proj.margin} Margin
                  </span>
                </div>
                <div className="h-1 w-full bg-charcoal-base rounded-full overflow-hidden">
                  <div className="h-full bg-invoice-green" style={{ width: proj.margin }} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="glass-panel rounded-xl p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-lg font-medium text-cream">Recent Activity</h2>
          <button className="text-xs text-cream-muted hover:text-cream transition-colors">View All</button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {[
            { text: 'INV-2042 paid by Acme Corp', time: '2h ago', icon: 'CheckCircle', color: 'text-invoice-green' },
            { text: 'New lead: Umbrella Corp', time: '5h ago', icon: 'UserPlus', color: 'text-blue-400' },
            { text: 'Globex UI at 95% budget', time: '1d ago', icon: 'AlertTriangle', color: 'text-red-400' },
            { text: 'Retainer renewed: Wayne Ent', time: '2d ago', icon: 'RefreshCw', color: 'text-purple-400' },
          ].map((activity, i) => (
            <div key={i} className="bg-charcoal-light/20 border border-[#333] p-4 rounded-xl flex gap-3">
              <div className={`mt-0.5 ${activity.color}`}>
                <SafeIcon name={activity.icon} className="w-4 h-4" />
              </div>
              <div>
                <p className="text-xs text-cream line-clamp-1">{activity.text}</p>
                <p className="text-[10px] text-cream-muted mt-1 uppercase tracking-wider">{activity.time}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}